import ouiBase from '@goldwasserexchange/oui';
import { useAccountPositionsHistoryFieldApiByHisMvtId } from '../api';

export const useAccountPositionsHistoryCCurrencyCodeByHisMvtId = () => {
  const hisMvtId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const result = useAccountPositionsHistoryFieldApiByHisMvtId({
    hisMvtId,
    field: 'C_CURRENCY.CODE',
  });
  return result;
};
